/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2023
 * @flow
 */

import React from 'react';
import { Chart } from 'react-chartjs-2';
import { Paper } from '@material-ui/core';
import useStyles from './useStyles';

const HourlySalesTipChart = ({ data, title }) => {
  const classes = useStyles();
  return (
    <Paper className={classes.paper} elevation={0}>
      <Chart
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              display: true,
              position: 'bottom',
            },
            title: {
              display: true,
              position: 'top',
              color: 'rgba(0, 0, 0, 0.54)',
              text: title,
              fullSize: true,
              font: {
                size: 14,
                weight: 400,
              },
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  let label = context.dataset.label || '';
                  let value = context.dataset.data[context.dataIndex];
                  if (context.dataset.type === 'line') {
                    const currency = context.dataset.currency || '';
                    value = `${currency}${value.toFixed(2)}`;
                  } else if (context.dataset.type === 'bar') {
                    value = `${Math.trunc(value)}%`
                  }
                  return `${label}: ${value}`;
                }
              }
            }
          },
        }}
        type='bar'
        data={data}
      />
    </Paper>
  );
};

export default HourlySalesTipChart;
